import {ShippingMean} from './shipping-mean';

export class ShippingType {
    id: number;
    description: string;
    shippingMeanList: ShippingMean[];
}
